export default "__VITE_PUBLIC_ASSET__bf08e092__"